import { LSICalculationRequestModel } from "./lsi-calculation.model";

export interface IOrendaChemicalHistoryModel {
    id: number;
    jobId: number;
    customerId: number;
    boratesCurrent: number;
    boratesDesired: number;
    calciumCurrent: number;
    calciumDesired: number;
    chlorineCurrent: number;
    chlorineDesired: number;
    cyaCurrent: number;
    cyaDesired: number;
    gallons: number;
    measurement: string;
    phCurrent: number;
    phDesired: number;
    phosphateCurrent: number;
    phosphateDesired: number;
    saltCurrent: number;
    saltDesired: number;
    totalAlkalinityCurrent: number;
    totalAlkalinityDesired: number;
    volume: number;
    waterTemperatureCurrentF: number;
    waterTemperatureDesiredF: number;
    structureId: number;
    createdDate: Date;
    lsiCurrent: number;
    lsiDesired: number;
    description: string;
    actionAndMaintenance: string;
    userId: number;
    userName: string;
}

export class OrendaChemicalHistoryModel implements IOrendaChemicalHistoryModel {
    id = 0;
    jobId = 0;
    customerId = 0;
    boratesCurrent = 0;
    boratesDesired = 0;
    calciumCurrent = 0;
    calciumDesired = 0;
    chlorineCurrent = 0;
    chlorineDesired = 0;
    cyaCurrent = 0;
    cyaDesired = 0;
    gallons = 0;
    measurement = '';
    phCurrent = 0;
    phDesired = 0;
    phosphateCurrent = 0;
    phosphateDesired = 0;
    saltCurrent = 0;
    saltDesired = 0;
    totalAlkalinityCurrent = 0;
    totalAlkalinityDesired = 0;
    volume = 0;
    waterTemperatureCurrentF = 0;
    waterTemperatureDesiredF = 0;
    structureId = 0;
    createdDate = new Date();
    lsiCurrent = 0;
    lsiDesired = 0;
    description = '';
    actionAndMaintenance: string;
    userId = 0;
    userName = '';

    static fromLSI(
        lsi: LSICalculationRequestModel,
        jobId: number,
        customerId: number,
        structureId: number,
        lsiCurrent: number,
        lsiDesired: number,
        actionAndMaintenance: string,
        userId: number,
        base?: Partial<OrendaChemicalHistoryModel>
    ): OrendaChemicalHistoryModel {
        const result = new OrendaChemicalHistoryModel();

        if (base) {
            Object.assign(result, base);
        }

        result.boratesCurrent = lsi.boratesCurrent ?? 0;
        result.boratesDesired = lsi.boratesDesired ?? 0;
        result.calciumCurrent = lsi.calciumCurrent ?? 0;
        result.calciumDesired = lsi.calciumDesired ?? 0;
        result.chlorineCurrent = lsi.chlorineCurrent ?? 0;
        result.chlorineDesired = lsi.chlorineDesired ?? 0;
        result.cyaCurrent = lsi.cyaCurrent ?? 0;
        result.cyaDesired = lsi.cyaDesired ?? 0;
        result.phCurrent = lsi.phCurrent ?? 0;
        result.phDesired = lsi.phDesired ?? 0;
        result.phosphateCurrent = lsi.phosphateCurrent ?? 0;
        result.phosphateDesired = lsi.phosphateDesired ?? 0;
        result.saltCurrent = lsi.saltCurrent ?? 0;
        result.saltDesired = lsi.saltDesired ?? 0;
        result.totalAlkalinityCurrent = lsi.totalAlkalinityCurrent ?? 0;
        result.totalAlkalinityDesired = lsi.totalAlkalinityDesired ?? 0;
        result.waterTemperatureCurrentF = lsi.waterTemperatureCurrentF ?? 0;
        result.waterTemperatureDesiredF = lsi.waterTemperatureDesiredF ?? 0;

        result.jobId = jobId;
        result.customerId = customerId;
        result.structureId = structureId;
        result.lsiCurrent = lsiCurrent;
        result.lsiDesired = lsiDesired;
        result.actionAndMaintenance = actionAndMaintenance;
        result.userId = userId;

        result.gallons = result.gallons ?? 0;
        result.volume = result.volume ?? 0;
        result.description = result.description ?? "";
        result.measurement = result.measurement ?? "gallons";

        return result;
    }
}

